'use client';

import { useEffect, useState } from 'react';
import classNames from 'classnames';
import { addFavorite, removeFavorite } from '~/app/actions/favorites-action';
import { getCookieAction } from '~/app/actions/client/get-cookie-action';
import { setCookieAction } from '~/app/actions/client/set-cookie-action';
import { useFavoriteStore } from '~/stores/favorite-store';

interface FavoriteButtonProps {
  jobId: number;
  isFavorite: boolean;
  isSignedIn: boolean;
  isMobile: boolean;
  favoriteJobIds: number[];
  className?: string;
}

export function FavoriteButton({
  jobId,
  isFavorite,
  isSignedIn,
  isMobile,
  favoriteJobIds,
  className = '',
}: FavoriteButtonProps) {
  const [isProcessing, setIsProcessing] = useState(false);
  const { addFavorite: addToStore, removeFavorite: removeFromStore } =
    useFavoriteStore();

  const handleClick = async () => {
    if (isProcessing) return;
    setIsProcessing(true);

    try {
      if (isSignedIn) {
        if (isFavorite) {
          await removeFavorite(jobId);
          removeFromStore(jobId);
        } else {
          await addFavorite(jobId);
          addToStore(jobId);
        }
      } else {
        const favorite_job_ids = JSON.parse(
          (await getCookieAction('favorite_job_ids')) || '[]',
        );
        if (isFavorite) {
          const updatedIds = favorite_job_ids.filter(
            (id: number) => id !== jobId,
          );
          await setCookieAction({
            key: 'favorite_job_ids',
            value: JSON.stringify(updatedIds),
          });
          removeFromStore(jobId);
        } else {
          const updatedIds = [...favorite_job_ids, jobId];
          await setCookieAction({
            key: 'favorite_job_ids',
            value: JSON.stringify(updatedIds),
          });
          addToStore(jobId);
        }
      }
    } catch (err) {
      console.error('お気に入り処理失敗:', err);
    } finally {
      setIsProcessing(false);
    }
  };

  return (
    <button
      className={classNames(
        'c-button -border-orange -heart-icon -sp-text-sm',
        isFavorite && '-solid -done',
        isMobile ? 'u-w150' : 'u-w280',
        className,
      )}
      onClick={handleClick}
      disabled={isProcessing}
    >
      {isFavorite ? 'お気に入り登録済' : 'お気に入り登録'}
    </button>
  );
}
